/**
 * 表单设计接口
 **/
import { Injectable } from '@angular/core';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class FormDesignService {
   //基础平台微服务api
   prefix: string = environment.seekerWebAPI;

   //文件处理微服务api
   filefix: string = environment.fileWebAPI;
 
   //任务调度微服务api
   schedulefix: string = environment.scheduleWebApi;
 
   constructor(
     private http: SwHttpClientService,
     private httpClient: HttpClient,
   ) {
   }

  //#region 表单设计接口

  /**
   * 查询表单列表(不包含参数)
   * @param param
   * @returns {Observable<any>}
   */
  findFormsPage(param) {
    const url = this.prefix + 'form/queryPageList';
    return this.http.Post(url, param);
  }

  /**
   * 根据formId查询参数
   * @param param
   * @returns {Observable<any>}
   */
  queryParamsPageList(formId) {
    let param = {
      entity: { formId: formId },
      param: { pageSize: 0, orderBy: "seq" }
    }
    const url = this.prefix + 'form/queryParamsPageList';
    return this.http.Post(url, { ...param });
  }

  /**
   * 新增表单
   * @param param
   * @returns {Observable<any>}
   */
  saveForm(param) {
    const url = this.prefix + 'form/save';
    return this.http.Post(url, param);
  }
  /**
   * 修改表单
   * @param param
   * @returns {Observable<any>}
   */
  updateForm(param) {
    const url = this.prefix + 'form/updateById';
    return this.http.Post(url, param);
  }
  /**
   * 删除表单
   * @param param
   * @returns {Observable<any>}
   */
  deleteForm(param) {
    const url = this.prefix + 'form/delete';
    return this.http.Post(url, param);
  }


  /**
   * 获取到所有表的信息
   * @param param
   * @returns {Observable<any>}
   */
  findTables(param) {
    const url = this.prefix + 'table/queryPageList';
    return this.http.Post(url, param);
  }

  /**
   * 根据TableID查询列
   * @param param
   * @returns {Observable<any>}
   */
  queryColumnsByTableId(param) {
    const url = this.prefix + 'table/queryColumnsByTableId';
    return this.http.Post(url,param);
  }

  /**
   * 根据TableID查询表格 
   * @param param
   * @returns {Observable<any>}
   */
  queryTableByTableId(param) {
    const url = this.prefix + 'table/queryById';
    return this.http.Post(url, param);
  }

  /**
   * 根据TableID更新表格   table/updateById
   * @param param
   * @returns {Observable<any>}
   */
  updateTableByTableId(param) {
    const url = this.prefix + 'table/updateById';
    return this.http.Post(url, param);
  }

  /**
   * 新增表格   table/updateById
   * @param param
   * @returns {Observable<any>}
   */
  addTable(param) {
    const url = this.prefix + 'table/save';
    return this.http.Post(url, param);
  }

  //#endregion


}
